import { BaseFetch } from "../main-model"
export default class SourceModel extends BaseFetch {
  getSourceById = (data) =>
    this.authFetch({
      url: "source/getSourceById", 
      method: "POST",
      body: JSON.stringify(data),
    })
    updateSourceById = (data) =>
    this.authFetch({
      url: "source/updateSourceById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertSource = (data) =>
    this.authFetch({
      url: "source/insertSource",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteSourceById = (data) =>
    this.authFetch({
      url: "source/deleteSourceById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
